
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import { environment } from '../../environments/environment';


@Injectable()
export class CityService {
    headers: Headers;
    options: RequestOptions;
    //APIURL = 'http://109.226.62.117/api/';
    APIURL =  environment.APIURL; // 'https://digilocally.deloitte.co.il/webapi/api/';
    //APIURL = 'http://iltlviis02/digLocally/webapi/api/';
    //APIURL = 'http://localhost/WebApi.Digilocali/api/';
    ImageURL =environment.ImageURL;//'https://digilocally.deloitte.co.il/assets/images/';
    //ImageURL = 'http://localhost:1337/assets/images/';
    cities: any = [];
    smallMarkerURL = this.ImageURL+'markers/';
    largeMarkerURL = this.ImageURL+'d-markers/';
    socioEconomicTitle = 'בחירת אשכול חברתי-כלכלי';
    dotImage = this.smallMarkerURL + 'dot.png'
    icons = [{ icon: '0.png' }, { icon: '1.png' }, { icon: '2.png' }, { icon: '3.png' }, { icon:  '4.png' },
    { icon: '5.png' }, { icon:'6.png' }, { icon: '7.png' }, { icon:'8.png' }, { icon: '9.png' }];

    districts = [{ viewValue: 'מחוז הצפון', value: 'הצפון' }, { viewValue: 'מחוז חיפה', value: 'חיפה' },
    { viewValue: 'מחוז המרכז ות"א', value: 'המרכז' },
    { viewValue: 'מחוז ירושלים ואיו"ש', value: 'ירושלים' }, { viewValue: 'מחוז הדרום', value: 'הדרום' }];

    localGovernments = [{ viewValue: 'עיריות', value: 'עיריות' }, { viewValue: 'מועצות אזוריות', value: 'מועצות אזוריות' }, { viewValue: 'מועצות מקומיות', value: 'מועצות מקומיות' }];

    indexs = [{ viewValue: 'אשכול 1', value: '1', enable: false, checked: false }, { viewValue: 'אשכול 2', value: '2', enable: false, checked: false }, { viewValue: 'אשכול 3', value: '3', enable: false, checked: false },
    { viewValue: 'אשכול 4', value: '4', enable: false, checked: false }, { viewValue: 'אשכול 5', value: '5', enable: false, checked: false }, { viewValue: 'אשכול 6', value: '6', enable: false, checked: false },
    { viewValue: 'אשכול 7', value: '7', enable: false, checked: false }, { viewValue: 'אשכול 8', value: '8', enable: false, checked: false }, { viewValue: 'אשכול 9', value: '9', enable: false, checked: false }, { viewValue: 'אשכול 10', value: '10', enable: false, checked: false },];


    colorArray: Array<string> = ['#13AAA2', '#137F80', '#166363', '#395654', '#5E5D46', '#DBA735', '#D36D1A', '#B75829', '#AA2721', '#D10909'].reverse();
    colorArr: Array<string> = ['13AAA2', '137F80', '166363', '395654', '5E5D46', 'DBA735', 'D36D1A', 'B75829', 'AA2721', 'D10909'].reverse();

    public calculateBackgroundStyles(ColorPlace: number) {
        var color = this.colorArr[ColorPlace];
        return "#" + color;
    }

    constructor(private _http: Http) {
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'q=0.8;application/json;q=0.9'
        });
        this.options = new RequestOptions({ headers: this.headers });
        
      }


    getBackgroundByTotal(total: number) {
        if (total != undefined) {
            let place = this.getColorPlace(total);
            return this.calculateBackgroundStyles(Number(place));
        }
    }

    textTotal: Array<string> = ['נמוכה מאוד', 'נמוכה מאוד', 'נמוכה', 'נמוכה', 'נמוכה- בינונית', 'נמוכה- בינונית', 'בינונית', 'בינונית- גבוהה', 'גבוהה', 'גבוהה מאוד'];
    getTextTotal(total: number) {
        if (isNaN(total))
            return '';
        let index = this.getColorPlace(total);
        return this.textTotal[index];

    }
    getColorPlace(val: number) {

        //debugger;

        if (val >= 91 && val <= 100)
            return 9;

        if (val >= 81 && val <= 90)
            return 8;

        if (val >= 71 && val <= 80)
            return 7;

        if (val >= 61 && val <= 70)
            return 6;

        if (val >= 51 && val <= 60)
            return 5;

        if (val >= 41 && val <= 50)
            return 4;

        if (val >= 31 && val <= 40)
            return 3;

        if (val >= 21 && val <= 30)
            return 2;

        if (val >= 11 && val <= 20)
            return 1;

        if (val >= 0 && val <= 10)
            return 0;
    }

    setDropDownTitleClass(obj) {
        if (!obj)
            return;
        if (obj.value == '')
            return 'blackTitle'
        else
            return 'blueTitle';
    }

    setSocioEconomicDropDownTitleClass(obj) {
        if (!obj)
            return;

        if (obj == this.socioEconomicTitle)
            return 'blackTitle'
        else
            return 'blueTitle';

    }

    setLocalGovernmentDropDownTitleClass(obj) {
        if (!obj)
            return;

        if (obj == 'בחירת סוג רשות')
            return 'blackTitle'
        else
            return 'blueTitle';
    }

    public getCountryTotalAvg() {
        return this._http.get(this.APIURL + `/home/getCountryTotalAvg`)
            .map((res: Response) => res.json());
    }

    public getAllCities() {
        return this._http.get(this.APIURL + `/home/ReadAllCities`)
            .map((res: Response) => res.json());
    }
    
    public getCityInfo(cityId: string) {
        return this._http.get(this.APIURL + '/home/getCityInfo?cityId=' + cityId)
            .map((res: Response) => res.json());
    }

    public getPercent(district: string, local: string, economic: string) {
        return this._http.get(this.APIURL + '/home/getPercent?dis=' + district + '&loc=' + local + '&eco=' + economic)
            .map((res: Response) => res.json());
    }

    getTotalAvg(): Observable<any> {
        return Observable.forkJoin([
            this._http.get(this.APIURL + '/home/getPercent').map(res => res.json()),
            this._http.get(this.APIURL + '/home/ReadAllCities').map(res => res.json())
        ])
            .map((data: any[]) => {
                let info = new Array(2);
                info[0] = data[0].data[0];
                info[1] = data[1];
                return info;
            });
    }

    getTotalAvgAndCity(cityId: string): Observable<any> {
        return Observable.forkJoin([
            this._http.get(this.APIURL + '/home/getCityInfo?cityId=' + cityId).map(res => res.json()),
            this._http.get(this.APIURL + '/home/getPercent').map(res => res.json()),
            this._http.get(this.APIURL + '/home/ReadAllCities').map(res => res.json())
        ])
            .map((data: any[]) => {
                let info = new Array(3);
                info[0] = data[0].data;
                info[1] = data[1].data[0];
                info[2] = data[2];
                return info;
            });
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    public saveForm(model: any): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this._http.post(this.APIURL + '/home/contactUsSave', model, options)
            .map(this.extractData)
            .catch(this.handleErrorObservable);
    }
    extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    handleErrorObservable(error: Response | any) {
        console.error(error.message || error);
        return Observable.throw(error.message || error);
    }

    public multiFilter(array, filters) {
        const filterKeys = Object.keys(filters);
        // filters all elements passing the criteria
        return array.filter((item) => {
            // dynamically validate all filter criteria
            return filterKeys.every(key => !!~filters[key].indexOf(item[key]));
        });
    }
}






// WEBPACK FOOTER //
// ./src/app/services/city.service.ts